export default __webpack_public_path__ + "static/project-slide-8-415-700-f930c427699d006dfd74effd9c11fc9a.webp";